import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  or: () => i18n.t(i18nKeys.common__or),
  reschedule: () => i18n.t(i18nKeys.scheduleOrientationDetails__reschedule),
  h1: () => i18n.t(i18nKeys.scheduleOrientationDetails__h1),
  bgTitle: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgTitle),
  bgStepOne: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepOne),
  bgStepTwo: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepTwo),
  ausBgStepOne: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepOne),
  bgStepThree: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepThree),
  bgStepFour: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepFour),
  bgStepFive: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepFive),
  whatToBring: () => i18n.t(i18nKeys.scheduleOrientationDetails__whatToBring),
  whatToBringOne: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBringOne),
  whatToBringTwo: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBringTwo),
  whatToBringThree: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBringThree),
  whatToBringTwoAlt: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBringTwoAlt),
  ausWhatToBringTwo: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__ausWhatToBringTwo),
  ausIdLink: () => i18n.t(i18nKeys.scheduleOrientationDetails__ausIdLink),
  prWhatToBringTwo: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__prWhatToBringTwo),
}
